import React from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  return <section className="bg-biosync-darkBg py-10 px-5 sm:px-10" data-id="element-311">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-312">
        <h2 className="text-white font-bold text-xl sm:text-2xl mb-8" data-id="element-313">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-6" data-id="element-314">
          <Countdown data-id="element-315" />
        </div>

        <p className="text-white/80 text-base mb-10" data-id="element-316">
          Después sube y no vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-317">
          <div className="flex justify-between text-white text-sm mb-2" data-id="element-318">
            <span data-id="element-319">🔴 Cupos al precio de lanzamiento</span>
            <span className="font-bold" data-id="element-320">Quedan pocos</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-3" data-id="element-321">
            <div className="bg-biosync h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-322"></div>
          </div>
        </div>
      </div>
    </section>;
};